/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMemberRequest
 */
export interface CreateMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMemberRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemberRequest
     */
    role: CreateMemberRequestRoleEnum;
}


/**
 * @export
 */
export const CreateMemberRequestRoleEnum = {
    Member: 'member',
    Admin: 'admin'
} as const;
export type CreateMemberRequestRoleEnum = typeof CreateMemberRequestRoleEnum[keyof typeof CreateMemberRequestRoleEnum];


/**
 * Check if a given object implements the CreateMemberRequest interface.
 */
export function instanceOfCreateMemberRequest(value: object): value is CreateMemberRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function CreateMemberRequestFromJSON(json: any): CreateMemberRequest {
    return CreateMemberRequestFromJSONTyped(json, false);
}

export function CreateMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'organizationId': json['organizationId'],
        'role': json['role'],
    };
}

export function CreateMemberRequestToJSON(json: any): CreateMemberRequest {
    return CreateMemberRequestToJSONTyped(json, false);
}

export function CreateMemberRequestToJSONTyped(value?: CreateMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'organizationId': value['organizationId'],
        'role': value['role'],
    };
}

